import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import {
  ModuleRegistry,
  ClientSideRowModelModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  QuickFilterModule,
  ExternalFilterModule,
  PaginationModule,
  CsvExportModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  RowApiModule,
  EventApiModule,
  RenderApiModule,
  ScrollApiModule,
  CellApiModule,
  CellStyleModule,
  ValidationModule,
} from 'ag-grid-community';

// Only register the AG Grid Community modules the app actually uses (client-side row model,
// basic column filters, quick filter, pagination, CSV export, column autosize/pin, cell styling)
// instead of AllCommunityModule, which pulls in unused features (cell editing, row drag,
// infinite row model, row selection, tooltips, aligned grids, etc.) and bloats the bundle.
// ValidationModule is kept so any missing-module usage logs a clear dev-console warning instead
// of failing silently.
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  QuickFilterModule,
  ExternalFilterModule,
  PaginationModule,
  CsvExportModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  RowApiModule,
  EventApiModule,
  RenderApiModule,
  ScrollApiModule,
  CellApiModule,
  CellStyleModule,
  ValidationModule,
]);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
